module.exports = __webpack_public_path__ + "static/media/logo.2f5c9d5b.png";